import {
  MiniTileContent,
  StyledChild,
  Title,
  Text,
} from "components/components/Iris/LandingPageInfo/GetStartedSection/Tile/style";
import Panel from "components/shared/Panel/Panel";
import React from "react";
import featureFlags from "utils/featureFlags";

type Props = {
  title: string | number;
  text: JSX.Element | string;
};

const Tile: React.FC<Props> = ({ title, text }) =>
  featureFlags.rebrand ? (
    <Panel isMiniTile>
      <MiniTileContent>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </MiniTileContent>
    </Panel>
  ) : (
    <div className="tile is-parent">
      <StyledChild className="tile is-child">
        <h3>{title}</h3>
        <p>{text}</p>
      </StyledChild>
    </div>
  );

export default Tile;
